import React from 'react';
import { constants } from '@wsb/guac-widget-core';
import { Divider } from '../../../SectionDivider/Divider';
import { getDividerHeight } from '../../../SectionDivider/heights';

const {
  renderModes: { PREVIEW }
} = constants;

export function WidgetDivider({ divider, color = 'section', ...rest }) {
  if (!divider || !divider.preset) return null;

  const { category, sectionColorOverride } = this.base;
  const resolvedColor =
    (color === 'section' && category === 'primary' && sectionColorOverride) ||
    String(this.mapPropValue('backgroundColor', color));

  const height = getDividerHeight(divider);
  const previewVisualOffset = '2px';

  // Temporary visual-top workaround; root cause is unconfirmed.
  const adjustedVisualTop =
    this.base.renderMode === PREVIEW
      ? `calc(-1 * ${height} + ${previewVisualOffset})`
      : `calc(-1 * ${height})`;

  return this.merge(
    {
      tag: 'div',
      style: { color: resolvedColor, position: 'relative', height: 0 },
      children: (
        <div
          style={{
            position: 'absolute',
            top: adjustedVisualTop,
            left: 0,
            width: '100%',
            height,
            zIndex: 1,
            pointerEvents: 'none'
          }}
        >
          <Divider
            preset={ divider.preset }
            amplitude={ divider.amplitude }
            depth={ divider.depth }
            position={ divider.position }
            steepness={ divider.steepness }
            softness={ divider.softness }
            fadeOpacity={ divider.fadeOpacity }
            fadeDirection={ divider.fadeDirection }
            fadeMidpoint={ divider.fadeMidpoint }
            height={ height }
          />
        </div>
      )
    },
    rest
  );
}
